import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';

import { IConfirmModalConfig } from '../../interfaces/modal-dialog-config.interface';
import { EditDocumentComponent } from '../../pages/edit-document/edit-document.component';
import { ModalDialogService } from '../../services/modalDialog/modal-dialog.service';

/**
 * editDocDeactivateGuard() is an Angular Guard method that runs every time when certain route is being deactivated.
 * @param changesKeys is a destructured prop from component passed to the function by Angular
 * @returns raw boolean or boolean observable that will represent a permission to destroy the component instance
 */
export const editDocDeactivateGuard: CanDeactivateFn<EditDocumentComponent> = ({
  changesKeys,
}: EditDocumentComponent) => {
  const modalService = inject(ModalDialogService);
  if (changesKeys.length) {
    const confirmConfig: IConfirmModalConfig = {
      title: 'Confirm Leave',
      message:
        'You are trying to leave the page. All your changes will not be saved. Do you wish to confirm and lose your edits?',
      confirmBtnLabel: 'Leave',
      confirmBtnCssClass: 'btn btn-danger px-sm-4',
      cancelBtnLabel: 'Stay',
    };
    return modalService.showConfirmModal(confirmConfig)!;
  }
  return true;
};
